import { render, staticRenderFns } from "./GeneralCheckersQueue.vue?vue&type=template&id=bb63e63c&"
import script from "./GeneralCheckersQueue.vue?vue&type=script&lang=js&"
export * from "./GeneralCheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports